import type { FC } from 'react'

import type { HeroDto } from '@hcr/api/optimizely'
import { CardVariant, unit } from '@hcr/ui'

import { useHomeQuery } from '../../hooks'
import { createHomeContent } from '../../utils'
import { LayoutNavigationError500 } from '../common'

import { HeaderHome, LayoutHome } from './common'
import { HomeLoading } from './HomeLoading'

const homeContent = createHomeContent({ slidesMargin: unit(3), variant: CardVariant.Regular })

interface HomeFallbackProps {
  hero: HeroDto
}

export const HomeFallback: FC<HomeFallbackProps> = ({ hero }) => {
  const home = useHomeQuery({ isAuthenticated: true })

  if (home.isError) {
    return <LayoutNavigationError500 showContextMenuButton />
  }

  if (home.isSuccess) {
    return (
      <LayoutHome
        imageUrl={hero.imageUrl}
        header={<HeaderHome />}
        content={home.data.content.map(homeContent)}
        showFallbackWarning
      />
    )
  }

  return <HomeLoading />
}
